import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import clsx from "clsx";
import { ListingCard } from "./ListingCard";
import type { Listing, Status } from "@/types";

interface LaneProps {
  status: Status;
  listings: Listing[];
}

export function Lane({ status, listings }: LaneProps) {
  const { setNodeRef, isOver } = useDroppable({ id: status });
  return (
    <section
      ref={setNodeRef}
      className={clsx(
        "flex flex-col w-[300px] flex-shrink-0 rounded-xl border border-ink-200 bg-white shadow-sm overflow-hidden transition-colors",
        isOver && "border-ink-500 bg-ink-50",
      )}
    >
      <header className="flex items-center justify-between px-3 py-2 bg-ink-50 border-b border-ink-200">
        <h2 className="text-sm font-medium text-ink-700">{status}</h2>
        <span className="text-xs text-ink-500 tabular-nums">
          {listings.length}
        </span>
      </header>
      <div className="lane-scroll flex-1 overflow-y-auto p-2 space-y-2">
        <SortableContext
          items={listings.map((l) => l.id)}
          strategy={verticalListSortingStrategy}
        >
          {listings.length === 0 && (
            <div className="text-xs text-ink-400 italic px-1 py-3 text-center">
              empty
            </div>
          )}
          {listings.map((l) => (
            <ListingCard key={l.id} listing={l} />
          ))}
        </SortableContext>
      </div>
    </section>
  );
}
